import isAndroid from './isAndroid';
import isPhone from './isPhone';
import isSymbian from './isSymbian';

const isPc = (): boolean => {
  return !isPhone() && !isAndroid() && !isSymbian();
};

export default isPc;
